import { Component, OnInit } from '@angular/core';
import { FolderShareService } from '../../service/folder-share/folder-share.service';
import { FolderShare } from '../../class/folder-share';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-folder-shares',
  templateUrl: './folder-shares.component.html',
  styleUrls: ['./folder-shares.component.scss']
})
export class FolderSharesComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public folderShares: FolderShare[];
    public selectFolderShare: FolderShare;
    public folderShareID: Number = 0;
    public modNew = false;
    public modView = false;
    public openFolderShare = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    public query: string;
    public first = 0;

    public filters: any[];

    public form3: FormGroup;
    public department_id_filter: AbstractControl;
    public candidate_id_filter: AbstractControl;
    public employee_id_filter: AbstractControl;

    public modExportDialog: boolean;
    public form4: FormGroup;
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;

    public apiUrl = config.API_ROOT;

    public es: any;

    constructor(
        public folderShareService: FolderShareService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        public fb: FormBuilder) { 
            this.form3 = fb.group({
                'candidate_id_filter': [''],
            });
            this.candidate_id_filter = this.form3.controls['candidate_id_filter'];    

            this.modExportDialog = false;            

            this.form4 = fb.group({
                'f4_date_start': ['', [Validators.required]],
                'f4_date_end': ['', [Validators.required]],
            });
            this.f4_date_start = this.form4.controls['f4_date_start'];
            this.f4_date_end = this.form4.controls['f4_date_end'];

            this.es = calendarES();            
        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        this.sort = '-id';
    
        //this.getFolderShare();
    }

    public loadFolderSharesLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        
        if (event.sortField) {
            if (event.sortOrder === -1) {
                this.sort = '-' + event.sortField;
            } else {
                this.sort = event.sortField;
            }
        } else {
            this.sort = '-id';
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }
                
        this.getFolderShare();
    }

    public getFolderShare() {
        this.folderShareService.getFolderShare(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.folderShares = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newFolderShare() {
        this.modNew = !this.modNew;
        this.selectFolderShare = null;
    }

    public savedFolderShare(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectFolderShare = null;
        this.modNew = false;
        this.getFolderShare();
    }

    public cancelFolderShare (res) {
        this.selectFolderShare = null;
        this.modNew = false;
        this.modView = false;
        this.getFolderShare();
    }

    public edit(folderShare: FolderShare) {
        this.modNew = true;
        this.selectFolderShare = folderShare;
        this.getFolderShare();
    }

    public view(folderShare: FolderShare) {
        this.openFolderShare = true;
        this.selectFolderShare = folderShare;
        this.folderShareID = folderShare.id;
        this.modView = true;
    }

    public deleteDialog(folderShare: FolderShare) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(folderShare);
            }
        });
    }

    public delete(folderShare: FolderShare) {
        this.folderShareService.deleteFolderShare(folderShare.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getFolderShare();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeFolderShare(folderShare: FolderShare) {
        this.putFolderShare(folderShare);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public putFolderShare(values: FolderShare) {
        const param = {
        };
        if (values) {
            const promise = this.folderShareService.updateFolderShare(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public filter (values?) {
        this.first = 0;
        this.filters = [];
        if (values) {
            if (values.candidate_id_filter) {
                this.filters.push({'key': 'candidate_id-lk', 'value': values.candidate_id_filter.id});
            }
        }

        this.getFolderShare();
    }

    public showExportDialog() {
        this.modExportDialog = true;
    } 

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/folder-shares/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=-id&';

        window.open(url, '_blank');
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/folder-shares/folder-shares.component.ts